<!-- 404 -->
<template>
    <div class="errorPage">
        <div class="main">
            <img src="../assets/images/no-root.png" alt="">
            <h1>当前用户没有访问权限，请联系管理员</h1>
        </div>
    </div>
</template>
<script>
    import mixin from  '@/mixins/mixin'
    export default {
        mixins: [mixin],
        name: '',
        components: {

        },
        data(){
            return {

            }
        },
        mounted(){

        },
        methods:{
            back(){
                window.history.back(-1)
            }
        }
    }
</script>
<style lang="less" scoped>
    .back {
        color: @theme;
        padding-top: 20px;
        cursor: pointer;
    }
    .errorPage {
        position: relative;
        height: calc(100% - 100px) !important;
        .main {
            text-align: center;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
            font-size: @font-lg;
        }
    }
</style>
